import type { ReadonlyDeep } from 'type-fest';

import { ResolvableBooleanInput } from '@e-socna/data-layer';

import { pruneInput } from '../../../utils/prune-input.util';
import type { ResolvableBooleanCmp_ResolvableBoolean } from '../../../components/ResolvableFields/ResolvableBoolean';

export function resolvableBooleanForm2ApiMapper(
  resolvableBoolean: ReadonlyDeep<ResolvableBooleanCmp_ResolvableBoolean>,
): ReadonlyDeep<ResolvableBooleanInput> {
  return pruneInput(resolvableBoolean, ResolvableBooleanInput);
}
